define('RSM.PriceLevelInventoryDisplay.Module.View'
,	[
		'rsm_pricelevelinventorydisplay_module.tpl'	,
		'SC.Configuration',
		'Profile.Model',
		'Backbone'
    ]
, function (
		rsm_pricelevelinventorydisplay_module_tpl,
		Configuration,
		ProfileModel,
		Backbone
)
{
    'use strict';

	return Backbone.View.extend({

		template: rsm_pricelevelinventorydisplay_module_tpl

	,	initialize: function (options) {
			this.item = options.pdp.getItemInfo();
		}
		
	,	getInventoryCount: function () {
			var quantity = this.item.item.quantityavailable;
			var userPriceLevel = ProfileModel.getInstance().get('priceLevel');

			var maxQuantityPerPriceLevel = _.findWhere(Configuration.get('pricelevelinventorydisplay'), {pricelevel: userPriceLevel.toString()});

			if (maxQuantityPerPriceLevel.maximum < quantity) {
				quantity = maxQuantityPerPriceLevel.maximum;
			}
			return quantity;
		}

	,	getContext: function getContext() {
			var inventory = this.getInventoryCount()
			return {
				inventory: inventory,
				displayInventory: inventory > 0
			};
		}
	});
});
